"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibleCampaignHolders = void 0;
var getVisibleCampaignHolders = exports.getVisibleCampaignHolders = function getVisibleCampaignHolders(staffPromoCode, promoCode, campaigns) {
  return staffPromoCode.includes(promoCode) ? campaigns.filter(function (c) {
    return c.key !== 'CBACampaign1';
  }) : campaigns;
};